module.exports = __webpack_public_path__ + "img/o_icon.e115eeff.png";